import { INERT } from 'actions/shared.types';
import { LT_FETCH } from 'bl/loggers.bl';
import { AUTH_API } from 'middleware/api';
import beVersion1 from 'middleware/beVersion1';
import beVersion3 from 'middleware/beVersion3';
import asArray from 'utils/arrays/asArray.util';
import { extendSession } from 'utils/cognito.util';
import logger from 'utils/logger.util';

const L = logger(['apiMiddleware', LT_FETCH]);

const USE_LOG_EVERY_ACTION = false;

const apiMiddleware = (store) => (next) => async (action) => {
  try {
    if (USE_LOG_EVERY_ACTION) L.debug('()', asArray(action?.AUTH_API?.types).join('/') || action?.type, action);

    if (!action) {
      const errorObject = new Error('Invalid action');
      const errorString = errorObject.toString();
      L.warn('()', 'Invalid action:', action, 'error:', errorObject, errorString);
      return next({ type: INERT.fail, errorObject, errorString, originalAction: action });
    }

    const ATAG = action?.ATAG;
    const v = action?.v;
    const beapi = action?.[AUTH_API];

    if (ATAG) L.debug('()', 'v:', v, 'ATAG:', ATAG, 'beapi:', beapi, 'action:', action);

    // NOTE: check so the middleware doesn't get applied to every single action
    if (!beapi) return next(action);

    const isVersion1 = !v || v < 3;
    const mw = isVersion1 ? beVersion1 : beVersion3;

    const options = { store, next, action };
    await extendSession(options);

    return mw(options);
  } catch (e) {
    L.warn('()', store, next, action, e);
    throw e;
  }
};

export default apiMiddleware;
